module.exports = __webpack_public_path__ + "img/SVG6_FutureExpenditure.21e54806.svg";